import {React ,useState}from "react";
import "./CompanyRegistration.css";
import { useNavigate } from "react-router-dom";
import ContactPopup from "./ContactPopup";
const CompanyRegistration = () => {
   const [openPopup, setOpenPopup] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="company-page">

      {/* HERO */}
      <section className="company-hero">
        <div className="hero-content">
          <h1>Company Registration</h1>
          <p>
            Register your business legally with expert support and hassle-free process.
          </p>
          <button className="primary-btn" onClick={() => window.location.href = "tel:9218103915"} >Get Free Consultation</button>
        </div>
      </section>

      {/* SERVICES */}
      <section className="company-services">
        <h2>Our Registration Services</h2>

        <div className="service-grid">
          <div
            className="card"
            onClick={() => navigate("/private-limited")}
          >
            <h3>Private Limited Company</h3>
            <p>Best for startups & scalable businesses</p>
          </div>

          <div className="card"
          onClick={() => navigate("/llp")}
          >
            <h3>LLP Registration</h3>
            <p>Low compliance with limited liability</p>
          </div>

          <div className="card"
          onClick={() => navigate("/opc")}
          >
            <h3>One Person Company</h3>
            <p>Single owner company with benefits</p>
          </div>

          <div className="card"
          onClick={() => navigate("/partnership")}
          >
            <h3>Partnership Firm</h3>
            <p>Easy setup for small businesses</p>
          </div>

          <div className="card"
          onClick={() => navigate("/sole")}
          >
            <h3>Proprietorship</h3>
            <p>Simple and quick registration</p>
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="process">
        <h2>Registration Process</h2>

        <div className="process-steps">
          <div className="step">
            <span>1</span>
            <p>Consultation & Document Collection</p>
          </div>

          <div className="step">
            <span>2</span>
            <p>Name Approval from MCA</p>
          </div>

          <div className="step">
            <span>3</span>
            <p>Filing Incorporation Documents</p>
          </div>

          <div className="step">
            <span>4</span>
            <p>Get Certificate of Incorporation</p>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="benefits">
        <h2>Benefits of Company Registration</h2>

        <div className="benefit-grid">
          <div>✔ Legal Business Identity</div>
          <div>✔ Limited Liability Protection</div>
          <div>✔ Easy Fund Raising</div>
          <div>✔ Brand Credibility</div>
          <div>✔ Tax Benefits</div>
          <div>✔ Business Expansion Opportunities</div>
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="documents">
        <h2>Required Documents</h2>

        <ul>
          <li>PAN Card of Directors</li>
          <li>Aadhar Card / ID Proof</li>
          <li>Address Proof</li>
          <li>Passport Size Photos</li>
          <li>Office Address Proof</li>
        </ul>
      </section>

      {/* CONTACT */}
      <section className="contact-box">
        <h2>Start Your Business Today</h2>
        <p>Talk to our experts and get your company registered quickly.</p>
        <button className="primary-btn" onClick={() => setOpenPopup(true)} >Contact Us</button>
          <ContactPopup
        isOpen={openPopup}
        onClose={() => setOpenPopup(false)}
      />
      </section>

    </div>
  );
};

export default CompanyRegistration;